import { useFormikFormContext } from '../FormikFormContext';

export interface IExtraInputProps {
  extraOptions?: {
    /**
     * Se `true`, distacca il componente dal context di Formik.
     * Attualmente l'unico effetto è la possibilità di gestire il disable
     * del componente indipendentemente dallo stato di formik.
     */
    detachFromContext?: boolean;
  };
}

export interface IBaseInputProps extends IExtraInputProps {
  disabled?: boolean;
}

/**
 * Hook per centralizzare le props dei componenti di input (TextInput, SelectInput, ...)
 */
export function useInputProps(props: IBaseInputProps) {
  const { disabled } = useFormikFormContext();

  return {
    disabled: props.extraOptions?.detachFromContext
      ? props.disabled
      : props.disabled || disabled
  };
}
